import { computed, signal } from '@angular/core';

export abstract class EntityStore<T> {
	private readonly _entity = signal<T | null>(null);
	entity = computed(() => this._entity()); // Reactive değeri almak için

	set(e: T): void {
		this._entity.set(e);
	}

	clear(): void {
		this._entity.set(null);
	}

	patch(p: Partial<T>): void {
		const current = this._entity();
		if (current) {
			this._entity.set({ ...current, ...p });
		}
	}

	// Anlık veriyi almak için (Dikkat: Template içerisinde kullanılırsa Angular Change Detection çalıştığı için yeniden çağrılır)
	get(): T | null {
		return this._entity();
	}
}
